
<template>
	<c-dialog ref="dialog" mode="slide" width="100vw-300" mask-close @close="dialogFormEditConfirm($refs.assembleForm, arguments)" @resolve="submitHandle">
		<c-form ref="assembleForm" column="3" vertical unit-width="100%">
			<c-form link-parent>
				<c-form-item label="装配工单编号">
					<c-input name="order_code" placeholder="请输入，不填将自动生成"></c-input>
				</c-form-item>
				<!-- <c-form-item :label="false" v-if="editState">
					<c-qrcode :value="h5_web" size="76"></c-qrcode>
				</c-form-item> -->
				<!--自定义字段数据-->
				<custom-form ref="customForm" work-type="34"></custom-form>
			</c-form>

			<c-title>产品明细</c-title>
			<c-form-item :label="false" name="product_list" colspan="3">
				<custom-table ref="productTable" view-id="10013" work-type="3">
					<template #operate>
						<c-button color="main" prepend-icon="tf-add" @click="globalDialog('productSelector', {props: {initParam: {product_sources:[1, 3]}}}, productSelectorHandle)">添加产品</c-button>
						<c-button prepend-icon="tf-add" @click="globalDialog('productSelector', {props: {initParam: {product_sources:[1]}, 'isProductBom': true}}, productBomSelectorHandle)">按BOM添加</c-button>
					</template>
					
					<template #otherOperate>
						<c-button prepend-icon="tf-edit" v-if="ref_type == 1" @click="workDatebyOrder()">按订单交期填充结束时间</c-button>
						<c-button v-if="auth('m_schedule_calendar')" v-lock="lock('m_schedule_calendar')" prepend-icon="tf-calendar" @click="windowTo({name: 'm_schedule_calendar'})">排产日历</c-button>
					</template>
					
					<c-table-column
						type="tree"
						label="BOM层级"
						width="300"
						name="childProduct"
						level-limit="5"
						:leaf-node="({data}) => !data.childProduct"
						@add="addChildProduct"
					>
						<template #default="{data}">
							{{data.product_name}}
						</template>
					</c-table-column>
					
					<!--工单编号-->
					<template #work_code="{data}">
						<span v-if="data.id">{{data.work_code}}</span>
						<span v-else>待生成</span>
					</template>
					
					<!--产品来源-->
					<template #product_source="{data}">
						<c-state dict="productSourceName" :value="data.product_source"></c-state>
					</template>
					
					<!--产品类型-->
					<template #product_type="{data}">
						<c-state dict="productTypeName" :value="data.product_type"></c-state>
					</template>
					
					<!--单位用量-->
					<template #unit_count="{data, nodeData}">
						<c-input name="unit_count" type="number" decimal="6" :range="[0.000001,99999999]" v-model="data.unit_count" :clear="false" @change="changeCount('unit',data, nodeData)"></c-input>
					</template>
					
					<!--计划数量-->
					<template #plan_count="{data, nodeData}">
						<c-input name="plan_count" type="number" decimal="2" :range="[0.01,99999999]" v-model="data.plan_count" :clear="false" @change="changeCount('count',data, nodeData)"></c-input>
					</template>
					
					<!--工单备注-->
					<template #remark="{data}">
						<c-input v-model="data.remark"></c-input>
					</template>
					
					<!--工单进度-->
					<template #process_rate="{data}">
						<process-rate v-if="data.id" :key="data._timestamp" :id="data.id"></process-rate>
						<span v-else>-</span>
					</template>
					
					<!--工单状态-->
					<template #work_state="{data}">
						<c-state v-if="data.id" dict="orderStateDic" :value="data.work_state"></c-state>
						<span v-else>-</span>
					</template>
					
					<!--优先级-->
					<template #priority="{data}">
						<c-state dict="priorityDic" tag :value="data.priority"></c-state>
					</template>
					
					<!--计划开始时间-->
					<template #plan_start_date="{data}">
						<c-datetime type="datetime" v-model="data.plan_start_date" time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
					</template>
					
					<!--计划结束时间-->
					<template #plan_end_date="{data}">
						<c-datetime type="datetime" v-model="data.plan_end_date" time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
					</template>
					
					<c-table-column
						type="button"
						label="操作"
						width="135"
					>
						<template #default="{data, nodeData, remove, addNode}">
							<c-table-button v-if="auth('b_assemble_create') || auth('b_assemble_edit')" :disabled="nodeData.level >= 4" icon="tf-add" @click="addNode()">添加下级</c-table-button>
							<c-table-button v-if="auth('b_assemble_create') || auth('b_assemble_edit')" icon="tf-trash" @click="removeProductRow(data,nodeData,remove)">删除</c-table-button>
						</template>
					</c-table-column>
				</custom-table>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	export default {
		name: 'assembleEdit',
		
		props: {
			ref_type: [Number, String],
			ref_id: Number,
			orderProductList: Array
		},
		
		data() {
			return {
				order_id:0,
				editState: false,
				h5_web:'',
				deleteProductList: []
			}
		},

		methods: {
			open(data) {
				//初始化自定义字段控件
				this.$refs.customForm.init();
				//初始化产品列表控件
				this.$refs.productTable.init();
				
				this.editState = !!data;
				
				this.deleteProductList = [];
				//清空表单数据
				this.$refs.assembleForm.clear();
				
				if (data) {
					this.order_id = data.id;
					this.getDetail();
				}else {
					this.order_id = 0;
					//转装配工单初始数据
					this.selectRefOrderProductHandle();
					//初始默认数据
					this.setLinkedData();
				}
				
				let ref_name = '';
				if(this.ref_type == 1) ref_name = '销售订单';
				if(this.ref_type == 2) ref_name = '生产计划';
				
				this.$refs.dialog.open({
					title: data ? '编辑装配工单' : ((this.orderProductList != null && this.orderProductList.length > 0)? ref_name+'转装配工单':'创建装配工单')
				});
			},
			
			//按销售订单、计划单转单进入时，自动将相关产品加入列表
			async selectRefOrderProductHandle() {
				if(this.orderProductList != null && this.orderProductList.length > 0){
					let source = [];
					!function loop(parentCount, list) {
						list && list.forEach(item => {
							item.unit_count = item.unit_count||1;
							if(parentCount){
								item.plan_count = parseFloat(((item.unit_count||1) * parentCount).toFixed(2));
							}else{
								item.plan_count = (item.unit_count||1) * item.main_product_count;
							}
							item.create_date = null;
							item.create_user_realname = null;
							item.order_id = item.order_id;
							item.order_product_id = item.id;
							item.plan_start_date = new Date().format('yyyy-MM-dd 00:00');
							item.plan_end_date = new Date().format('yyyy-MM-dd 23:59');
							source.push([{
								ref_work_type_id: 1,
								ref_id: item.order_id
							}, {
								ref_work_type_id: 41,
								ref_id: item.id
							}, {
								ref_work_type_id: 2,
								ref_id: item.order_id
							}, {
								ref_work_type_id: 48,
								ref_id: item.id
							}, {
								ref_work_type_id: 7,
								ref_id: item.product_id
							}]);
							item.id = null;
							loop(item.plan_count, item.childProduct);
						});
					}(null, this.orderProductList);
					
					this.$refs.productTable.$refs.list.push(
						await this.$refs.productTable.setDefaultData(defaultData => {
							let index = 0;
							!function loop(list) {
								list && list.forEach(item => {
									item.custom_fields_value_json = Object.assign(defaultData[index++], item.custom_fields_value_json)
									loop(item.childProduct);
								});
							}(this.orderProductList);
							return this.orderProductList;
						}, {
							work_type_id: 3,
							source_list: source
						})
					);
				}
			},
			
			//初始默认数据（从销售订单、计划单转单时）
			setLinkedData() {
				this.$refs.customForm.setDefaultData({
					work_type_id: 34,
					source_list: [[{
						ref_work_type_id: 1,
						ref_id: this.ref_id
					}, {
						ref_work_type_id: 2,
						ref_id: this.ref_id
					}]]
				});
			},
			
			/**按订单交期填写工单计划结束时间**/
			workDatebyOrder(){
				const dataList = this.$refs.productTable.$refs.list.getRow();
				dataList.forEach(item => {
				    item.update({plan_end_date: item.data.plan_delivery_date});
				})
			},
			
			/*******搜索装配工单详情*******************/
			getDetail() {
				this.request({
					url:'/assemble/detail',
					data: {
						id: this.order_id
					},
					loading: true,
					success: data => {
						//产品列表
						!function loop(list) {
							list && list.forEach(item => {
								loop(item.childProduct);
							});
						}(data.productList);
						
						this.h5_web = data.detailInfo.h5_web;
						//装配工单基本信息
						this.$refs.assembleForm.set(data.detailInfo);
						
						//加载工单列表
						this.$refs.productTable.$refs.list.setData(data.productList);
					}
				});
			},
			
			changeCount(type, data, nodeData){
				//改单位用量
				if (nodeData.level > 0 && type=='unit') {
					data.plan_count = parseFloat((data.unit_count * nodeData.parent.data.plan_count).toFixed(2));
				}
				//改计划数量
				if (nodeData.level > 0 && type=='count') {
					data.unit_count = parseFloat((data.plan_count / nodeData.parent.data.plan_count).toFixed(6));
				}
				
				!function loop(list) {
					list && list.forEach(row => {
						row.data.plan_count = parseFloat(((row.data.unit_count||1) * row.nodeData.parent.data.plan_count).toFixed(2));
						loop(row.nodeData.children);
					});
				}(nodeData.children);
			},
			
			/******添加产品响应方法*********/
			async productSelectorHandle(data) {
				this.$refs.productTable.$refs.list.push(
					await this.$refs.productTable.setDefaultData(data.map(item => {
						return Object.assign({}, item, {
							id: null,
							create_date: null,
							create_user_realname: null,
							product_id: item.id,
							unit_count: 1,
							plan_count: 1,
							plan_start_date: new Date().format('yyyy-MM-dd 00:00'),
							plan_end_date: new Date().format('yyyy-MM-dd 23:59')
						});
					}), {
						work_type_id: 3,
						source_list: data.map(item => {
							return [{
								ref_work_type_id: 7,
								ref_id: item.product_id
							}]
						})
					})
				);
			},
			
			/******按BOM添加产品响应方法*********/
			productBomSelectorHandle(data) {
				this.request({
					url:'/product/children/all_list',
					data: {
						product_source: [1],		//只查询自产产品
						product_ids: data.map(item => {
							return item.id;
						})
					},
					success: async data => {
						let source = [];
						!function loop(list) {
							list && list.forEach(item => {
								item.id = null;
								item.unit_count = item.unit_count||1;
								item.plan_count = (item.unit_count||1) * 1;
								item.create_date = null;
								item.create_user_realname = null;
								item.plan_start_date = new Date().format('yyyy-MM-dd 00:00');
								item.plan_end_date = new Date().format('yyyy-MM-dd 23:59');
								source.push([{
									ref_work_type_id: 7,
									ref_id: item.product_id
								}]);
								loop(item.childProduct);
							});
						}(data);
						
						this.$refs.productTable.$refs.list.push(
							await this.$refs.productTable.setDefaultData(defaultData => {
								let index = 0;
								!function loop(list) {
									list && list.forEach(item => {
										item.custom_fields_value_json = Object.assign(defaultData[index++], item.custom_fields_value_json)
										loop(item.childProduct);
									});
								}(data);
								return data;
							}, {
								work_type_id: 3,
								source_list: source
							})
						);
					}
				});
			},
			
			/******添加下级********/
			addChildProduct(row, resolve) {
				this.globalDialog('productSelector', {props: {initParam: {product_sources:[1]}}}, data => {
					data.forEach(item => {
						item.product_id = item.id;
						item.id = null;
						item.unit_count = 1;
						item.plan_count = row.data.plan_count;
						item.create_date = null;
						item.create_user_realname = null;
						item.plan_start_date = new Date().format('yyyy-MM-dd 00:00');
						item.plan_end_date = new Date().format('yyyy-MM-dd 23:59');
						resolve(Object.assign({}, item));
					});
				});
			},
			
			/******删除产品行数据********/
			removeProductRow(data, nodeData, remove) {
				if (data.id && data.id > 0){
					this.deleteProductList.push(data.id);
					!function loop(list) {
						list && list.forEach(row => {
							if (row.data.id && row.data.id > 0){
								this.deleteProductList.push(row.data.id);
								loop.call(this, row.nodeData.children);
							}
						});
					}.call(this, nodeData.children);
				}
				remove();
			},

			/*******提交编辑数据********************/
			submitHandle(stop, next) {
				stop();
				
				//产品工单列表
				var product_list = this.$refs.productTable.$refs.list.getRow();
				
				this.$refs.assembleForm.submit({
					url: this.order_id==0?'/assemble/add':'/assemble/edit',
					rule: {
						product_list: data => { 
							var flag = true;
							if(product_list.length == 0){
								let msg = "请至少有一个产品信息";
								return msg;
							} 
							if (
								this.$refs.productTable.$refs.list.getRow(({data}) => {
									return !data.plan_count || !data.plan_start_date || !data.plan_end_date;
								}).length
							) {
								let msg = "请完善产品明细";
								return msg;
							}
							//自定义字段校验
							return this.$refs.productTable.validate();
						},
						...this.$refs.customForm.rule
					},
					dataFormatter: data => {
						data.id = this.order_id||0;
						data.ref_type = this.ref_type||0;
						data.ref_id = this.ref_id;
						//产品列表
						let loop = list => {
							if (!list) return [];
							return list.map(row => {
								let item = row.data;
								return {
									id: item.id,
									product_id: item.product_id,
									order_id: item.order_id||(this.ref_type==1? this.ref_id:null),
									order_product_id: item.order_product_id,
									unit_count: item.unit_count,
									plan_count: item.plan_count,
									plan_start_date: item.plan_start_date,
									plan_end_date: item.plan_end_date,
									remark: item.remark,
									custom_fields_value_json: JSON.stringify(item.custom_fields_value_json),
									childProduct: loop(row.nodeData.children)
								}
							});
						};
						data.product_list = loop(product_list);
						//被删除的任务ID列表
						data.delete_product_list = this.deleteProductList.map(item => {
							return {id:item}
						});
						//表单自定义字段
						data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
						return data;
					},
					success: () => {
						next();
						this.$message({
							type: 'success',
							message:this.editState ? '编辑装配工单成功' : '创建装配工单成功',
						});
						//刷新页面
						this.$emit('resolve');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>